<template>
  <div class="container">
    <div class="row" v-if="hasData">
      <div class="col">
        <RiskIndexFullDetail :organizationId="organizationId" :reportId="reportId" :report="report" />
      </div>
    </div>
  </div>
</template>

<script>
import RiskIndexFullDetail from "@/views/reports/report/edit-report/RiskIndexFullDetail.vue";

export default {
  components: {
    RiskIndexFullDetail,
  },
  props: {
    organizationId: String,
    reportId: String,
  },
  data() {
    return {
      report: null,
    };
  },
  computed: {
    hasData() {
      if (this.report && this.report.summary && this.report.summary.scoreCode === "inconclusive") return false;
      if (this.statusCode === "completed") return true;
      return false;
    },
    statusCode() {
      if (this.report && this.report.statusCode) return this.report.statusCode;
      return "unknown";
    },
  },
  created() {
    this.$axios
      .get(`/v1/organizations/${this.organizationId}/reports/${this.reportId}`)
      .then(res => (this.report = res.data))
      .catch(err => (this.error = err))
      .finally(() => this.print());
  },
  methods: {
    print() {
      setTimeout(() => (window.printReady = true), 500);
    },
  },
};
</script>
